import { createReducer, on } from '@ngrx/store';
import { GameSession } from '../../models/game.model';
import * as GameSessionActions from './game-session.actions';

export interface GameSessionState {
  currentSession: GameSession | null;
}

export const initialState: GameSessionState = {
  currentSession: null
};

export const gameSessionReducer = createReducer(
  initialState,
  on(GameSessionActions.setCurrentSession, (state, { session }) => ({
    ...state,
    currentSession: session
  })),
  on(GameSessionActions.clearCurrentSession, state => ({
    ...state,
    currentSession: null
  }))
);
